import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ExternalLink, Phone } from 'lucide-react';
export function AgencyPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (hasBeenDismissed) return;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      if (scrollPercentage > 0.5 && !isVisible) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasBeenDismissed, isVisible]);
  const handleClose = () => {
    setIsVisible(false);
    setHasBeenDismissed(true);
  };
  return <AnimatePresence data-id="element-9">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 right-6 z-50 max-w-sm w-[calc(100%-3rem)] bg-white rounded-3xl shadow-[0_20px_40px_rgb(0,0,0,0.08)] border border-slate-100 overflow-hidden" data-id="element-10">
          <div className="p-6" data-id="element-11">
            <div className="flex justify-between items-start mb-4" data-id="element-12">
              <div className="flex items-center gap-2" data-id="element-13">
                <div className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" data-id="element-14" />
                <span className="font-bold text-xs uppercase tracking-widest text-slate-900" data-id="element-15">
                  Розробка сайтів
                </span>
              </div>
              <button onClick={handleClose} className="p-1.5 bg-slate-50 hover:bg-slate-100 rounded-full text-slate-400 hover:text-slate-600 transition-colors" data-id="element-16">
                <X className="w-4 h-4" data-id="element-17" />
              </button>
            </div>

            <p className="text-slate-500 text-sm leading-relaxed mb-5" data-id="element-18">
              Цей сайт ми можемо зробити для вас повністю під ключ, адаптувати
              під всі ваші потреби.
            </p>

            <div className="bg-slate-50 rounded-2xl p-3 mb-6 text-center" data-id="element-19">
              <span className="font-bold text-slate-900 text-sm" data-id="element-20">
                Вартість під ключ — 8 000 грн.
              </span>
            </div>

            <div className="space-y-2" data-id="element-21">
              <a href="tel:+380508399309" className="flex items-center justify-center gap-2 w-full py-3 bg-slate-900 hover:bg-slate-800 text-white rounded-2xl transition-all duration-300 text-sm font-semibold" data-id="element-22">
                <Phone className="w-4 h-4" data-id="element-23" />
                +380 50 839 9309
              </a>
              <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full py-3 bg-white hover:bg-slate-50 text-slate-900 border border-slate-200 rounded-2xl transition-all duration-300 text-sm font-semibold" data-id="element-24">
                <ExternalLink className="w-4 h-4" data-id="element-25" />
                jetly.agency/ua
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}